export const stageBarBackground = {
  background: "grey9",
  display: "flex",
  flexDirection: "row",
  textTransform: "uppercase",
};

export const stageStatus = ({ isComplete, isInProgress }) => ({
  background: isComplete ? "black" : isInProgress ? "primary" : "grey9",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignItems: "center",
  padding: "5px 10px",
  gap: "10px",
  zIndex: 1000,
  color: (isComplete || isInProgress) && "white",
  fontWeight: !isComplete && !isInProgress && "300",
});

export const checkBox = ({ isInProgress }) => ({
  border: "solid 1px",
  borderRadius: "1px",
  borderColor: isInProgress ? "white" : "black",
  height: "12px",
  width: "12px",
  marginTop: "auto",
  marginBottom: "auto",
});
